import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IonFabButton, IonIcon, IonSpinner } from '@ionic/angular';

@Component({
    selector: 'lib-time-clock-fab-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if(this.isLoading()) {
        <ion-fab-button size="small">
            <ion-spinner name="dots"></ion-spinner>
        </ion-fab-button>
        }@else {
        <ion-fab-button size="small" [color]="isClockedIn() ? 'danger' : 'success'" (click)="toggleClockedInStatus.emit()">
            <ion-icon name="time" color="light"></ion-icon>
        </ion-fab-button>
        }
    `,
    styles: [],
    imports: [IonFabButton, IonIcon, IonSpinner],
})
export class TimeClockFabButtonComponent {
    isLoading = input<boolean>(true);
    isClockedIn = input<boolean>(false);
    toggleClockedInStatus = output<void>();
}
